import { render, staticRenderFns } from "./FixedBottomLeftArea.vue?vue&type=template&id=266f09d6&scoped=true"
import script from "./FixedBottomLeftArea.vue?vue&type=script&lang=js"
export * from "./FixedBottomLeftArea.vue?vue&type=script&lang=js"
import style0 from "./FixedBottomLeftArea.vue?vue&type=style&index=0&id=266f09d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_359e2a22b61d78988ed9bf0e7b495bd0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266f09d6",
  null
  
)

export default component.exports